import IntegrationType from "../../../../types/integration/IntegrationType";
import NotificationIntegrationList from "../NotificationIntegrationList";
import { NOTIFICATION_INTEGRATIONS } from "../../../../helpers/notificationIntegrations";

function List(props: { loading: number, pagerDuty: IntegrationType[], refresh: Function, isAdmin: boolean }) {
    return (
        <NotificationIntegrationList
            loading={props.loading}
            parameters={props.pagerDuty}
            refresh={props.refresh}
            isAdmin={props.isAdmin}
            config={NOTIFICATION_INTEGRATIONS.pagerduty}
            iconClass="fak fa-pagerduty"
            endpointLabel="Event endpoint"
            endpointKey="url"
        />
    );
}

export default List;
